"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _breakpoints = require("../breakpoints");
var _LexusButton = _interopRequireDefault(require("../LexusButton"));
var _Link = _interopRequireDefault(require("../Link"));
var _index = _interopRequireDefault(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
const CTAList = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  let {
    ctas = [],
    size = "normal",
    themeOverride = "",
    ctaMobileExperience = "sideToSide",
    alignCtas = "left",
    additionalAnalytics = {},
    className,
    children
  } = _ref;
  const flags = {
    mobile: (0, _breakpoints.useMobileBreakpoint)(),
    tablet: (0, _breakpoints.useTabletBreakpoint)(),
    desktop: (0, _breakpoints.useDesktopBreakpoint)({
      up: true
    })
  };
  const breakpointToCheck = Object.keys(flags).find(function (k) {
    return flags[k];
  });
  const breakpointCtas = ctas.filter(function (c) {
    return !c.breakpoints || c.breakpoints.length === 0 || c.breakpoints.indexOf(breakpointToCheck) > -1;
  });
  const buckets = breakpointCtas.reduce(function (acc, cta) {
    const existingBucket = acc.find(function (bucket) {
      return bucket.type === cta.type;
    });
    if (existingBucket !== null && existingBucket !== void 0 && existingBucket.bucket) {
      existingBucket.bucket.push(cta);
    } else {
      const newBucket = {
        type: cta.type,
        bucket: [cta],
        key: `${cta.type}-${cta.text}-${acc.length}`
      };
      acc.push(newBucket);
    }
    return acc;
  }, []);
  const displayType = alignCtas === "full-width" ? "block" : "inline-block";
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.CTAListWrapper, {
    ref: ref,
    $displayType: displayType,
    className: className,
    "data-testid": "CTAList",
    children: buckets.map(function (_ref2) {
      let {
        bucket,
        key
      } = _ref2;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Bucket, {
        $alignCtas: alignCtas,
        "data-testid": "CTAList",
        children: bucket.map(function (_ref3, index) {
          let {
            type,
            theme,
            text,
            breakpoints,
            ariaLabel,
            ...cta
          } = _ref3;
          const trimmedTheme = theme === null || theme === void 0 ? void 0 : theme.trim();
          if (breakpoints && breakpoints.length > 0 && breakpoints.indexOf(breakpointToCheck) === -1) return null;
          return type === "button" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.CTAWrapper, {
            className: "cta-wrapper",
            $ctaMobileExperience: ctaMobileExperience,
            $buttonSize: size,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LexusButton.default, {
              ...cta,
              className: "lexus-button",
              size: size,
              text: text,
              theme: themeOverride ? themeOverride : trimmedTheme,
              index: index,
              count: breakpointCtas.length,
              ariaLabel: ariaLabel,
              additionalAnalytics: additionalAnalytics
            })
          }, text) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.AnchorWrapper, {
            theme: trimmedTheme,
            $ctaMobileExperience: ctaMobileExperience,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
              ...cta,
              index: index,
              count: breakpointCtas.length,
              "aria-label": ariaLabel || text,
              additionalAnalytics: additionalAnalytics,
              children: text !== null && text !== void 0 ? text : children
            })
          }, text);
        })
      }, key);
    })
  });
});
var _default = exports.default = CTAList;